'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconLink, iconLinkTag } from '@ni/nimble-components/dist/esm/icons/link';
import { wrap } from '../../utilities/react-wrapper';

export type { IconLink };
export { iconLinkTag };
export const NimbleIconLink = wrap(IconLink);